export default {
  'menu.overview': '概要',
  'menu.fund': 'ファンド',
  'menu.fund.list': 'ファンド一覧',
  'menu.fund.formation': '新設承認',
  'menu.fund.formationDetail': '新設詳細',
  'menu.fund.detail': 'ファンド詳細',
  'menu.fundraising': '募集フォロー',
  'menu.fundraising.board': '募集ボード',
  'menu.fundraising.opportunities': '出資者案件',
  'menu.fundraising.opportunityDetail': '案件詳細',
  'menu.lpAndContact': '出資者と連絡先',
  'menu.lpAndContact.lp': '出資機関',
  'menu.lpAndContact.contact': '連絡先',
  'menu.contribution': '払込・入金',
  'menu.setting': '設定',
  'menu.setting.dictionary': '辞書',
  'menu.setting.permissions': '権限',
  'menu.setting.modelSettings': 'モデル設定',
  'menu.login': 'ログイン',
  'menu.account': 'アカウント',
  'menu.account.center': 'プロフィール',
  'menu.account.workbench': 'ワークベンチ',
  'menu.account.logout': 'ログアウト',
};
